import React, { useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { string, bool, shape } from 'prop-types';
import { Heading, Text, Box } from '@landtrustinc/design-system';
import LegacySectionSeasonInfo from '../ListingPage/SectionSeasonInfo';
import SectionPackageSeasonInfo from './SectionPackageSeasonInfo';

import SectionHelpfulResources from '../ListingPage/SectionHelpfulResources';
import css from './SectionHuntingInformation.module.css';

const SectionSeasonInfo =
  process.env.REACT_APP_SEASON_INFO_SOURCE === 'views'
    ? SectionPackageSeasonInfo
    : LegacySectionSeasonInfo;

const SectionHuntingInformation = ({
  currentPackage,
  currentListing,
  publicData,
  licenseLink,
  regulationsLink,
  showRegulationsLink,
}) => {
  const { species_unit: speciesUnit } = currentPackage;
  const [viewsRegulationsLink, setViewsRegulationsLink] = useState(null);
  const usesViews = process.env.REACT_APP_SEASON_INFO_SOURCE === 'views';

  return (
    <div className={css.root}>
      <Heading size="2xs" color="var(--text-primary)" fontWeight="bold">
        <FormattedMessage id="PackagePage.huntingInformationTitle" />
      </Heading>

      {speciesUnit && (
        <Box display="flex" flexDirection="column" gap="var(--spacing-3)" mt="var(--spacing-3)">
          <Box>
            <Text fontWeight="bold">
              <FormattedMessage id="PackagePage.gameManagementUnit" />
            </Text>
            <p className={css.gmuValue}>{speciesUnit}</p>
          </Box>

          <div className={css.seasonInfoWrapper}>
            <SectionSeasonInfo
              publicData={publicData}
              currentPackage={currentPackage}
              currentListing={currentListing}
              onRegulationsSourceChange={usesViews ? setViewsRegulationsLink : undefined}
            />
          </div>
        </Box>
      )}

      <Box mt="var(--spacing-3)">
        <SectionHelpfulResources
          licenseLink={licenseLink}
          regulationsLink={(usesViews && viewsRegulationsLink) || regulationsLink}
          showRegulationsLink={showRegulationsLink}
        />
      </Box>
    </div>
  );
};

SectionHuntingInformation.defaultProps = {
  licenseLink: null,
  regulationsLink: null,
  showRegulationsLink: false,
  currentListing: null,
};

SectionHuntingInformation.propTypes = {
  currentPackage: shape({}).isRequired,
  currentListing: shape({}),
  publicData: shape({}).isRequired,
  licenseLink: string,
  regulationsLink: string,
  showRegulationsLink: bool,
};

export default injectIntl(SectionHuntingInformation);
